import InfoPageContacts from './info-page-contacts';
export default InfoPageContacts;
